var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"order-payment-method-details","title":"Detalles del Pago","hide-footer":""}},[_c('payment-details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }